import Jumbotron from './Jumbotron';
import { Link } from 'react-router-dom';

const Books = ()=> {
    return ( 
        <>
        <Jumbotron />
        <div className="page-padd mt-4">
        <div className="row">
                    <div className="col-12">
                        <h3 className="mb-4 text-center">C++ Programming</h3>
                    </div>
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Order Book Here</h5>
                                <a href="#" className="btn btn-primary text-white">American Press Publishers</a>
                            </div>
                        </div>
                        <h5 className="mb-4 mt-4">Features of C++ Programming: Easy Ways</h5>
                        <ul className="list-group mb-4">
                            <li className="list-group-item">Explores easy ways to learn programming in C++</li>
                            <li className="list-group-item">Makes the most difficult programming concepts understandable
                            </li>
                            <li className="list-group-item">Transitions from C language to C++</li>
                            <li className="list-group-item">Invites readers to participate and interact</li>
                            <li className="list-group-item">Presents materials from different angles</li>
                            <li className="list-group-item">Suitable for beginners and those who are more advanced</li>
                            <li className="list-group-item">Focuses on practical learning with input and output examples
                            </li>
                            <li className="list-group-item">Covers data structures, procedural, and object-oriented
                                programming</li>
                            <li className="list-group-item">Combines both theory and practical applications</li>
                        </ul>
                        <h5>Additional Websites</h5>
                        <ul className="list-group mb-4">
                            <li className="list-group-item"><a href="https://www.programiz.com/cpp-programming"
                                    target="_blank">C++ Easy Programming</a></li>
                            <li className="list-group-item"><a href="https://americanpresspublishers.com/Ebrahimi.html"
                                    target="_blank">American Press-C++ Programming: Easy Ways by Alireza Ebrahimi </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="card-title">Quick Video Guides On C++</h5>
                                <a href="https://www.youtube.com/user/PROGRAMMINGEASYWAYS" target="_blank"
                                    className="btn btn-info text-white">Quick C++ Video</a>
                            </div>
                        </div>

                        <h5 className="mb-4 mt-4">C++ Programming: Easy Ways Volume One</h5>
                        <ul className="list-group mb-4">
                            <li className="list-group-item"><Link to="/chap01">Chapter 1: Evolution of Computer Programming and Languages</Link></li>
                            <li className="list-group-item"><Link to="/chap03">Chapter 2: Input, Process, Output (IPO)</Link></li>
                            <li className="list-group-item"><Link to="/chap04">Chapter 3: Loop: Doing It Over and Over</Link></li>
                            <li className="list-group-item"><Link to="/chap04">Chapter 4: Decision Making: Making Programs
                                    Intelligent</Link></li>
                            <li className="list-group-item"><Link to="/chap05">Chapter 5: Array: Arrangement of Data</Link></li>
                            <li className="list-group-item"><Link to="/chap06">Chapter 6: Function: Organizing the Program</Link></li>
                            <li className="list-group-item"><Link to="/chap07">Chapter 7: Structure: Putting Related Items Together</Link></li>
                            <li className="list-group-item"><Link to="/chap08">Chapter 8: Object and Class: Everything as an Object of a Class</Link></li>
                            <li className="list-group-item"><Link to="/chap09">Chapter 9: File Handling: A Database</Link></li>
                            <li className="list-group-item">Chapter 10: Recursion: Function Calling Itself </li>
                            <li className="list-group-item"><Link to="/chap011">Chapter 11: Sorting Algorithms and Analysis</Link></li>
                            <li className="list-group-item">Chapter 12: Searching to Look and to Find</li>
                            <li className="list-group-item"><a target='_blank' href="http://www.drebrahimi.com/Data/Sites/1/chapter13full.pdf">Chapter 13: Sorting Algorithms and Analysis</a></li>
                            <li className="list-group-item">Appendix A: Visual C++6.0 Edit, Compile, and Run</li>
                            <li className="list-group-item">Appendix B: Visual C++.NET Edit, Compile, and Run</li>
                            <li className="list-group-item">Appendix C: Borland C++5.02 Edit, Compile, and Run with Debugger</li>
                            <li className="list-group-item">Appendix D: Linux GNU C++</li>
                            <li className="list-group-item">Bibliography</li>

                           </ul>
                            <h5 className="mt-4"><a href="http://drebrahimi.com/chapter13full.pdf" target="_blank">C++ Programming: Easy Ways
                                Volume Two</a></h5>
                        <ul className="list-group mb-4">
                            <li className="list-group-item"><a href="#">Chapter 14: Data Structures</a></li>
                            <li className="list-group-item"><a href="http://www.drebrahimi.com/Data/Sites/1/chpt15full.pdf"
                                    target="_blank">Chapter 15: Polymorphism, Template, and ADT</a></li>
                            <li className="list-group-item"><a href="http://www.drebrahimi.com/Data/Sites/1/chpt16full.pdf"
                                    target="_blank">Chapter 16: Inheritance: Reusability and Extendability</a></li>
                            <li className="list-group-item"><a href="#">Chapter 17: Character Manipulations, String Class
                                    and Iostream</a></li>
                         <li className="list-group-item">Chapter 17: Character manipulations, String Class and Iostream</li>
                         <li className="list-group-item">Chapter 18: Standard Template Library </li>
                         <li className="list-group-item">Chapter 19: Errors, Exception handling and Software Engineering    </li>
                         <li className="list-group-item"><Link to="/chap20">Chapter 20: Potpourri (Mixed Bag)</Link></li>
                         <li className="list-group-item">General Tests, Projects and Solutions</li>
                         <li className="list-group-item">Sample Case Study Solution</li>
                         <li className="list-group-item">Index</li>

                        </ul>
                    </div>
                </div>
            <div className="mt-3">
                <iframe frameBorder="0" height="300" title="myFrame"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
                    className="iframeStyle">
                </iframe>
            </div>
        </div>
        </>
     );
}

export default Books;